import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AppComponent from './AppComponent'
import { getUserInfo, getLoadingInfo } from '../../redux/selectors'

class AppContainer extends React.PureComponent {
  render () {
    const {
      error,
      authorized,
      history,
      loading,
      contactLoading,
      contactsLoading,
      exclusionsLoading,
      emailPreferencesLoading,
      databasePreferencesLoading
    } = this.props

    return (
      <AppComponent
        error={error}
        authorized={authorized}
        history={history}
        loading={loading}
        contactLoading={contactLoading}
        contactsLoading={contactsLoading}
        exclusionsLoading={exclusionsLoading}
        emailPreferencesLoading={emailPreferencesLoading}
        databasePreferencesLoading={databasePreferencesLoading}
      />
    )
  }
}

AppContainer.propTypes = {
  error: PropTypes.object,
  authorized: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  contactLoading: PropTypes.bool.isRequired,
  contactsLoading: PropTypes.bool.isRequired,
  exclusionsLoading: PropTypes.bool.isRequired,
  emailPreferencesLoading: PropTypes.bool.isRequired,
  databasePreferencesLoading: PropTypes.bool.isRequired
}

const mapStateToProps = state => ({
  error: getUserInfo(state).error,
  authorized: getUserInfo(state).authorized,
  loading: getLoadingInfo(state).loading,
  contactLoading: getLoadingInfo(state).contactLoading,
  contactsLoading: getLoadingInfo(state).contactsLoading,
  exclusionsLoading: getLoadingInfo(state).exclusionsLoading,
  emailPreferencesLoading: getLoadingInfo(state).emailPreferencesLoading,
  databasePreferencesLoading: getLoadingInfo(state).databasePreferencesLoading
})

const AppConnect = connect(mapStateToProps, null)(AppContainer)

export default AppConnect
